module.exports = __webpack_public_path__ + "fonts/4c53ab0.ttf";